export default __webpack_public_path__ + "static/media/goods4.8c4e258e.gif";